import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';
import { f as forwardEvent } from './index3.js';
import { a as toValue, t as toLabel } from './index5.js';
import { i as isOtherOption } from './index6.js';
import { H as HiddenHTMLSelect } from './hidden-html-select.js';
import { d as defineCustomElement$e } from './box.js';
import { d as defineCustomElement$d } from './check-input.js';
import { d as defineCustomElement$c } from './divider.js';
import { d as defineCustomElement$b } from './form-field.js';
import { d as defineCustomElement$a } from './icon.js';
import { d as defineCustomElement$9 } from './list.js';
import { d as defineCustomElement$8 } from './list-item.js';
import { d as defineCustomElement$7 } from './list-item-divider.js';
import { d as defineCustomElement$6 } from './list-item-header.js';
import { d as defineCustomElement$5 } from './list-item-meta.js';
import { d as defineCustomElement$4 } from './loader.js';
import { d as defineCustomElement$3 } from './status.js';
import { d as defineCustomElement$2 } from './tooltip.js';
import { d as defineCustomElement$1 } from './tooltip-label.js';

const checkListInputCss = ":host{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;box-sizing:border-box;font-family:Open Sans;font-size:.875rem;font-weight:400;letter-spacing:-.0004em;line-height:1.25rem;line-height:normal;min-width:100%}:host *,:host :after,:host :before{box-sizing:inherit}:host img{flex:none;overflow:hidden;text-overflow:ellipsis;white-space:pre-line}";
const WuiCheckListInputStyle0 = checkListInputCss;

const WuiCheckListInput = /*@__PURE__*/ proxyCustomElement(class WuiCheckListInput extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.handleInput = (e, option) => {
            // Stop the inner input event from bubbling up
            e.stopPropagation();
            const val = toValue(option);
            if (typeof val === 'undefined') {
                return;
            }
            if (this.value?.includes(val)) {
                this.value = this.value.filter((v) => v !== val);
            }
            else {
                this.value = [...(this.value ?? []), val];
            }
            this.el.dispatchEvent(new window.Event('input', { bubbles: true }));
        };
        this.value = undefined;
        this.options = [];
        this.name = undefined;
        this.list = undefined;
        this.disabled = false;
    }
    render() {
        return (h(Host, { key: '85329cc72f11e2dd121b920c4025ef89d17cf4e9' }, h(HiddenHTMLSelect, { key: '216be411330f2d6890751460f2b430dc3cc9d6df', disabled: this.disabled, options: this.options, value: this.value, name: this.name, multiple: true }), h("wui-list", { key: '8c91dfcf51e85d8b01dc9581ec49850a80031a54', ...this.list, onFocus: (e) => {
                forwardEvent(e, this.el);
            }, onBlur: (e) => {
                forwardEvent(e, this.el);
            } }, this.options?.map((option, idx) => {
            if (isOtherOption(option)) {
                switch (option.type) {
                    case 'header':
                        return h("wui-list-item-header", { key: idx, ...option });
                    case 'divider':
                        return h("wui-list-item-divider", { key: idx });
                    case 'meta':
                        return h("wui-list-item-meta", { key: idx, ...option });
                }
            }
            const isOptionChecked = (this.value || []).includes(`${toValue(option)}`);
            const isOptionDisabled = typeof option === 'object' && option.disabled;
            const description = typeof option === 'object' ? option.description : undefined;
            return (h("wui-list-item", { key: idx, checkable: true, checked: isOptionChecked, disabled: this.disabled || isOptionDisabled, onInput: (e) => this.handleInput(e, option), label: toLabel(option), description: description }));
        }))));
    }
    get el() { return this; }
    static get style() { return WuiCheckListInputStyle0; }
}, [1, "wui-check-list-input", {
        "value": [1040],
        "options": [16],
        "name": [1],
        "list": [16],
        "disabled": [4]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["wui-check-list-input", "wui-box", "wui-check-input", "wui-divider", "wui-form-field", "wui-icon", "wui-list", "wui-list-item", "wui-list-item-divider", "wui-list-item-header", "wui-list-item-meta", "wui-loader", "wui-status", "wui-tooltip", "wui-tooltip-label"];
    components.forEach(tagName => { switch (tagName) {
        case "wui-check-list-input":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, WuiCheckListInput);
            }
            break;
        case "wui-box":
            if (!customElements.get(tagName)) {
                defineCustomElement$e();
            }
            break;
        case "wui-check-input":
            if (!customElements.get(tagName)) {
                defineCustomElement$d();
            }
            break;
        case "wui-divider":
            if (!customElements.get(tagName)) {
                defineCustomElement$c();
            }
            break;
        case "wui-form-field":
            if (!customElements.get(tagName)) {
                defineCustomElement$b();
            }
            break;
        case "wui-icon":
            if (!customElements.get(tagName)) {
                defineCustomElement$a();
            }
            break;
        case "wui-list":
            if (!customElements.get(tagName)) {
                defineCustomElement$9();
            }
            break;
        case "wui-list-item":
            if (!customElements.get(tagName)) {
                defineCustomElement$8();
            }
            break;
        case "wui-list-item-divider":
            if (!customElements.get(tagName)) {
                defineCustomElement$7();
            }
            break;
        case "wui-list-item-header":
            if (!customElements.get(tagName)) {
                defineCustomElement$6();
            }
            break;
        case "wui-list-item-meta":
            if (!customElements.get(tagName)) {
                defineCustomElement$5();
            }
            break;
        case "wui-loader":
            if (!customElements.get(tagName)) {
                defineCustomElement$4();
            }
            break;
        case "wui-status":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "wui-tooltip":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
        case "wui-tooltip-label":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}
defineCustomElement();

export { WuiCheckListInput as W, defineCustomElement as d };

//# sourceMappingURL=check-list-input.js.map